import { memo } from 'react';
import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';
import Tag from 'shared/Tag';

import { DEFAULT_BORDER_RADIUS } from 'constants/global';

const SkillCard = ({
  title,
  subTitle,
  tags = null,
  illustration,
  illustrationProps = null,
  contentContainerProps = null,
  tagsContainerProps = null,
}) => (
  <Flex
    w="full"
    h={{ laptop: '426px', tablet: '360px', mobile: '272px' }}
    p={{ laptop: '48px', tablet: '28px', mobile: '20px' }}
    borderRadius={DEFAULT_BORDER_RADIUS}
    bgColor="bg.gray"
    pos="relative"
    overflow="hidden"
  >
    {/* Box нужен чтобы картинка не сжималась самостоятельно если её ширина больше чем ширина карточки */}
    <Box position="absolute" zIndex="0" {...illustrationProps}>
      <NextImage src={illustration} alt={`Иллюстрация карточки ${title}`} w="full" h="full" />
    </Box>

    <VStack
      w="full"
      maxW={{ mobile: '187px', tablet: '171px', laptop: '300px' }}
      gap={{ mobile: '20px', laptop: '30px' }}
      align="start"
      zIndex="1"
      {...contentContainerProps}
    >
      <VStack w="full" align="start" gap="8px">
        <Text as="h3" fontSize={{ mobile: '24px', laptop: '32px', desktop: '48px' }}>
          {title}
        </Text>

        <Text textStyle="h1" fontWeight="500" fontSize={{ laptop: '24px' }}>
          {subTitle}
        </Text>
      </VStack>

      {tags && (
        <HStack
          w="full"
          maxW="280px"
          gap="6px"
          flexWrap="wrap"
          align="start"
          {...tagsContainerProps}
        >
          {tags.map((tag, i) => (
            <Tag
              key={i}
              textStyle="h2"
              whiteSpace="nowrap"
              fontWeight="500"
              p={{ mobile: '6px 12px', laptop: '7px 16px' }}
            >
              {tag}
            </Tag>
          ))}
        </HStack>
      )}
    </VStack>
  </Flex>
);

export default memo(SkillCard);
